module.exports = __webpack_public_path__ + "img/youhodler.f774c430.svg";